import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-refresh\"><path d=\"M750.933 273.067c-56.889-62.578-142.222-102.4-238.933-102.4-187.733 0-341.333 153.6-341.333 341.333S324.267 853.333 512 853.333c159.289 0 290.133-108.089 329.956-256h-91.023C716.8 694.044 620.09 768 512 768c-142.222 0-256-113.778-256-256s113.778-256 256-256c68.267 0 136.533 28.444 182.044 73.956L557.511 466.489h295.822V170.667l-102.4 102.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol